import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ChunkPipe } from './array/chunk.pipe'
import { IncludesPipe } from './array/includes.pipe'
import { IndexOfPipe } from './array/indexOf.pipe'
import { IsArrayPipe } from './array/isArray.pipe'
import { JoinPipe } from './array/join.pipe'
import { KeysPipe } from './array/keys.pipe'
import { LengthPipe } from './array/length.pipe'
import { Base64Pipe } from './atyl/base64.pipe'
import { ConsultationHeadingPipe } from './atyl/consultationHeading.pipe'
import { DisplayLieuPipe } from './atyl/displayLieu.pipe'
import { DisplayProfessionnelsPipe } from './atyl/displayProfessionnels.pipe'
import { DisplayTitlePipe } from './atyl/displayTitle.pipe'
import { HasLieuPipe } from './atyl/hasLieu.pipe'
import { InputLabelPipe } from './atyl/inputLabel.pipe'
import { LabeledDatePipe } from './date/labeled-date.pipe'
import { NowPipe } from './date/now.pipe'
import { DefaultPipe } from './string/default.pipe'
import { KebabCasePipe } from './string/kebab-case.pipe'
import { SafeHtmlPipe } from './string/safe-html.pipe'
//import { SafePipe } from './string/safe.pipe'

const PIPES = [
	LabeledDatePipe,
	SafeHtmlPipe,
	//SafePipe,
	ChunkPipe,
	KebabCasePipe,
	DefaultPipe,
	IncludesPipe,
	IndexOfPipe,
	IsArrayPipe,
	JoinPipe,
	KeysPipe,
	LengthPipe,
	NowPipe,
	DisplayTitlePipe,
	InputLabelPipe,
	Base64Pipe,
	ConsultationHeadingPipe,
	DisplayLieuPipe,
	HasLieuPipe,
	DisplayProfessionnelsPipe
]
@NgModule({
	declarations: [
		...PIPES
	],
	imports: [
		CommonModule
	],
	exports: [
		...PIPES
	],
	providers: [
		...PIPES
	]
})
export class PipesModule { }
